export default __webpack_public_path__ + "static/media/email.895927eb.svg";